import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SpaceListTypeLayer from "../../components/StorageSpaceType/SpaceListTypeLayer";


const SpaceTypeListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Storage Type" />

        {/* UsersListLayer */}
        <SpaceListTypeLayer />

      </MasterLayout>

    </>
  );
};

export default SpaceTypeListPage; 
